import { Link } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import tanoEdLogo from '../../assets/logoTanoEd.png';

/**
 * Footer GLOBAL de l'espace élève (rendu une seule fois dans le shell, donc
 * présent sur toutes les pages : Accueil / Île / Blasons / Moi / Résultats).
 * Charte simple et accessible : <footer> sémantique, contraste suffisant,
 * focus visible, liens et bouton clairement étiquetés. Déconnexion (icône)
 * UNIQUEMENT pour les non-GAR. `mb-16` = espace réservé pour la tabbar fixe.
 */
const lienClass = 'rounded px-0.5 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan-300 transition-colors';

function FooterEleve({ isGarEleve, onLogout }) {
  return (
    <footer
      className="px-4 py-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[11px] font-medium"
      style={{ color: 'rgba(255,255,255,.62)', background: 'rgba(8,20,40,.97)', borderTop: '1px solid rgba(255,255,255,.08)' }}
    >
      <img src={tanoEdLogo} alt="TanoEd" className="h-4 w-auto opacity-90 mr-1" />
      <Link to="/mentions" className={lienClass}>Mentions légales</Link>
      <span aria-hidden="true">·</span>
      <Link to="/rgpd" className={lienClass}>RGPD</Link>
      <span aria-hidden="true">·</span>
      <Link to="/cgu" className={lienClass}>CGU</Link>
      {!isGarEleve && (
        <>
          <span aria-hidden="true">·</span>
          <button
            type="button"
            onClick={onLogout}
            aria-label="Se déconnecter"
            title="Se déconnecter"
            className="inline-flex items-center rounded p-0.5 hover:text-red-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-300 transition-colors"
          >
            <LogOut className="w-3.5 h-3.5" aria-hidden="true" />
          </button>
        </>
      )}
    </footer>
  );
}

export default FooterEleve;
